<template>
  <div v-if="isShow()">
    <div class="d-flex align-items-center gap-2">
      <input
          v-model="fields.val"
          @input="onInput"
          type="text"
          class="form-control"
          placeholder="Url магазина (только цифры, маленькие латинские буквы и тире)"
          @change="changeItem"
      />
      <template v-if="isShowSyncBtn()">
        <span class="sync-slug-by-title" @click="syncSlugByTitle" title="Синхронизировать url по заголовку">
          <button class="btn btn-icon btn-primary">
            <template v-if="isSyncProcess()">
              <span class="spinner-border spinner-border-sm me-2"></span>
            </template>
            <template v-else>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-refresh"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4" /><path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4" /></svg>
            </template>
          </button>
        </span>
      </template>
    </div>
    <span :class="{'is-invalid': v$.slug.$invalid && v$.slug.$dirty}"></span>
    <div class="invalid-feedback" v-for="error of v$.slug.$errors" :key="error.$uid">
      {{ error.$message }}
    </div>
  </div>
</template>

<script>
import {defineComponent, onMounted, reactive, ref, watch} from "vue"
import Api from "./services/Api"
import Helper from "@/services/Helper";

export default defineComponent({
  name: "Slug",
  components: {},
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
    validation: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, {emit}) {
    let show = ref(false)
    let syncProcess = ref(false)
    let v$ = ref({})

    const fields = reactive({
      val: null,
      shop_id: null,
      title: null,
    })

    onMounted(async () => {
      updateFields(props.payload)

      markUnshow()
      markShow()
    })

    watch(() => props.payload.val, (v) => {
      fields.val = v
    }, {
      immediate: true,
    })

    watch(() => props.payload.title, (v) => {
      fields.title = v
    }, {
      immediate: true,
    })

    watch(() => props.validation, (v) => {
      v$.value = v
    }, {
      immediate: true,
    })

    function updateFields(query) {
      fields.val = query.val
      fields.shop_id = query.shop_id
      fields.title = query.title
    }

    function markShow() {
      show.value = true
    }

    function markUnshow() {
      show.value = false
    }

    function isShow() {
      return show.value === true
    }

    function changeItem(e) {
      pushEvent(e.target.value)
    }

    function pushEvent(val) {
      emit("onChange", val)
    }

    function onInput(e) {
      // только маленькие латинские буквы, цифры и тире
      let cleaned = e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, "");

      // заменяем два и более тире подряд на один
      cleaned = cleaned.replace(/-+/g, "-");

      fields.val = cleaned;
    }

    function getFieldPostId() {
      return fields.shop_id
    }

    function getFieldTitle() {
      return fields.title
    }

    async function syncSlugByTitle() {
      if (confirm("Будет обновлен url по заголовку, продолжить?")) {
        try {
          startSyncProcess()
          await Api.syncSlugByTitle(getFieldPostId(), getFieldTitle())
          emit("onSync", true)
        } catch (resp) {
          console.log(resp)
          
          emit("onSync", false)
        } finally {
          stopSyncProcess()
        }
      }
    }

    function startSyncProcess() {
      syncProcess.value = true
    }

    function stopSyncProcess() {
      syncProcess.value = false
    }

    function isSyncProcess() {
      return syncProcess.value === true
    }

    function isShowSyncBtn() {
      return !Helper.isEmpty(fields.shop_id)
    }

    return {
      isShow,
      fields,
      changeItem,
      onInput,
      syncSlugByTitle,
      isSyncProcess,
      isShowSyncBtn,
      v$,
    }
  }
})
</script>

<style scoped src="./css/style.css">

</style>
